import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcLogOut24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m4 18a3 3 0 0 0 3 3h4c.563 0 1-.438 1-1 0-.563-.438-1-1-1h-4c-.563 0-1-.438-1-1v-12c0-.563.438-1 1-1h4c.563 0 1-.438 1-1 0-.563-.438-1-1-1h-4a3 3 0 0 0 -3 3zm5.5-6c0 .531.438 1 1 1h7.594l-2.282 2.281a1.043 1.043 0 0 0 -.28.719c0 .563.437 1 .968 1 .25 0 .531-.125.719-.313l4-3.968c.187-.188.281-.469.281-.719s-.094-.531-.281-.719l-4-3.969a.95.95 0 0 0 -1.406 0 .97.97 0 0 0 -.283.688c0 .25.094.5.281.719l2.284 2.281h-7.595c-.563 0-1 .438-1 1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcLogOut24;
